// ------------------------------------------------------
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import "../assets/Sidebar.css";
import {
  FaUser,
  FaCogs,
  FaUserPlus,
  FaUsers,
  FaIdCard,
  FaSearch,
  FaCalendarCheck,
  FaClipboardCheck,
  FaCalendarAlt,
  FaFolderOpen,
  FaCheckCircle,
  FaFileAlt,
  FaBook,
  FaCoins,
  FaEnvelope,
  FaLock,
  FaFilePdf,
  FaCalculator,
  FaHandHoldingUsd,
  FaFileInvoiceDollar,
  FaChartLine,
  FaWallet,
  FaChartBar,
  FaClock,
  FaUserFriends,
  FaBriefcase,
  FaChevronRight,
  FaChevronDown,
  FaBolt,
} from "react-icons/fa";
import {
  CalendarClock,
  Users,
  AlertTriangle,
  Clock4,
  CheckCircle2,
  FileDown,
  Plus,
} from "lucide-react";
import { FaRupeeSign } from "react-icons/fa";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  // Sidebar open/close
  const [isExpanded, setIsExpanded] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);

  // Keep track of which submenu is open
  const [openSubMenu, setOpenSubMenu] = useState({});

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
    setShowOverlay(!showOverlay);
  };

  // Toggle a submenu open/close
  const handleMainClick = (item, key) => {
    if (item.subItems) {
      setOpenSubMenu((prev) => ({
        ...prev,
        [key]: !prev[key], // toggle only this key
      }));
    } else if (item.path) {
      navigate(item.path);
    }
  };

  // Check if a path is active
  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { text: "Dashboard", path: "/Dashboard", icon: <FaUser /> },
    {
      icon: <FaCogs />,
      text: "Manage Master",
      subItems: [
        {
          text: "Manage Company",
          path: "/ManageCompany",
          icon: <FaUserPlus />,
        },
        { text: "Loan Scheme", path: "/LoanScheme", icon: <FaIdCard /> },
        { text: "Saving Scheme", path: "/SavingScheme", icon: <FaIdCard /> },
        { text: "RD Scheme", path: "/RDScheme", icon: <FaIdCard /> },
        { text: "FD Scheme", path: "/FDScheme", icon: <FaIdCard /> },
        {
          text: "Gold Loan Scheme",
          path: "/GoldLoan/GoldLoanScheme",
          icon: <FaIdCard />,
        },

        {
          text: "Group Loan Scheme",
          path: "/GroupLoanScheme",
          icon: <FaIdCard />,
        },
        // { text: "Vehicle Loan Scheme", path: "/VehicleLoan/VehicleLoanScheme", icon: <FaIdCard /> },

        {
          text: "Assign Document",
          path: "/AssignDocument",
          icon: <FaSearch />,
        },
        { text: "Role Master", path: "/RoleMaster", icon: <FaCalendarCheck /> },
        { text: "SMS Master", path: "/SmsMaster", icon: <FaCalendarAlt /> },
        // { text: "SMS Gateway", path: "/ManageMaster/SmsGateway", icon: <FaCalendarAlt /> },
        { text: "Fee Master", path: "/FeeMaster", icon: <FaFolderOpen /> },
        {
          text: "Branch Master",
          path: "/BranchMaster",
          icon: <FaCheckCircle />,
        },
        // {
        //   text: "Series Master",
        //   path: "/ManageMaster/SeriesMaster",
        //   icon: <FaCheckCircle />,
        // },
        {
          text: "Agent Commission Master",
          path: "/AgentCommissionMaster",
          icon: <FaHandHoldingUsd />,
        },
        { text: "Manage Holiday", path: "/HolidayForm", icon: <FaFileAlt /> },
        {
          text: "Manage Permission",
          path: "/ManagePermission",
          icon: <FaBook />,
        },
        {
          text: "Company Bank Account",
          path: "/CompanyBankAccount",
          icon: <FaCoins />,
        },
        // {
        //   text: "Manage Company Capital",
        //   path: "/CompanyCapital",
        //   icon: <FaCheckCircle />,
        // },
        // {
        //   text: "Wallet",
        //   path: "/ManageMaster/Wallet",
        //   icon: <FaCheckCircle />,
        // },
        // { text: "Product Loan", path: "/ProductLoan", icon: <FaCoins /> },
        // { text: "Contact Us", path: "/ContactUs", icon: <FaEnvelope /> },
      ],
    },
     {
      icon: <FaBriefcase />,
      text: "Product Master",
      subItems: [
        { text: "Product Scheme", path: "/ProductMaster/ProductScheme", icon: <FaUsers /> },
        {
          icon: <FaUser />,
          text: "Product Master",
          subItems: [
            {
              text: "Category",
              path: "/ProductMaster/Category",
              icon: <FaIdCard />,
            },
            {
              text: "Brand",
              path: "/ProductMaster/Brand",
              icon: <FaIdCard />,
            },
            {
              text: "Model",
              path: "/ProductMaster/Model",
              icon: <FaIdCard />,
            },
            {
              text: "Varient",
              path: "/ProductMaster/Varient",
              icon: <FaIdCard />,
            },
          ]
        },
        { text: "Product Details", path: "/ProductDetails", icon: <FaIdCard /> },
        { text: "Vender Master", path: "/ProductMaster/VenderMaster", icon: <FaIdCard /> },
        { text: "Product Loan Report", path: "/ProductMaster/ProductLoanReport", icon: <FaIdCard /> },
        { text: "Emi Due Report", path: "/ProductMaster/ProductEmiDueReport", icon: <FaIdCard /> },
        { text: "Collection Report", path: "/ProductMaster/ProductCollectionReport", icon: <FaIdCard /> },
      ],
    },
    {
      icon: <FaUser />,
      text: "Customer",
      subItems: [
        // { text: "Search Customer", path: "/SearchCustomer", icon: <FaUserPlus /> },
        // { text: "Customer Create", path: "/CustomerCreate", icon: <Plus /> },
        { text: "Customer KYC", path: "/CustomerKyc", icon: <FaIdCard /> },
        {
          text: "Customer Report",
          path: "/CustomerReport",
          icon: <FaFileAlt />,
        },
        // { text: "Group Member", path: "/GroupMember", icon: <FaFileAlt /> },
      ],
    },
   
    {
      icon: <FaBriefcase />,
      text: "HR Module",
      subItems: [
        { text: "Create Employee", path: "/CreateEmployee", icon: <FaUsers /> },
        { text: "Employee KYC", path: "/EmployeeKyc", icon: <FaIdCard /> },
        {
          text: "Employee Report",
          path: "/EmployeeReport",
          icon: <FaFileAlt />,
        },
        { text: "Update Password", path: "/UpdatePassword", icon: <FaLock /> },
        {
          text: "Employee Letter",
          path: "/EmployeeLetter",
          icon: <FaFilePdf />,
        },
        { text: "Leave Report", path: "/LeaveReport", icon: <FaFileAlt /> },

        { text: "Salary Master", path: "/SalaryMaster", icon: <FaCoins /> },
        {
          text: "Salary Master Report",
          path: "/SalaryReport",
          icon: <FaFileAlt />,
        },

        {
          text: "Attendance",
          path: "/AttendanceCalculator",
          icon: <FaCalendarCheck />,
        },
        {
          text: "Calculate Salary",
          path: "/AttendanceSummary",
          icon: <FaCalendarCheck />,
        },
        // { text: "Calculate Salary", path: "/CalculateSalary", icon: <FaCalculator /> },
        // { text: "Agent Commission", path: "/AgentCommission", icon: <FaHandHoldingUsd /> },
        {
          text: "Salary Disbursement",
          path: "/SalaryDisbursement",
          icon: <FaFileInvoiceDollar />,
        },
        // { text: "Disbursement Report", path: "/DisbursementReport", icon: <FaChartLine /> },
        // { text: "User Wallet", path: "/WalletMaster", icon: <FaWallet /> },
        {
          text: "Fund Request Approval",
          path: "/FundApproval",
          icon: <FaCheckCircle />,
        },
        // { text: "Fund Approval Report", path: "/FundApprovalReport", icon: <FaFileAlt /> },
      ],
    },
    {
      icon: <FaBriefcase />,
      text: "Manage Loans",
      subItems: [
        { text: "Loan Reports", path: "/LoanReport", icon: <FaChartBar /> },
        { text: "Applied Loans", path: "/Report", icon: <FaClock /> },
        // { text: "Loan KYC", path: "/Loan/KycLoanDetail", icon: <FaChartBar /> },
        {
          text: "Pending Disbursal",
          path: "/PendingDisbursal",
          icon: <FaClock />,
        },
        {
          text: "Disbursement Report",
          path: "/LoanDisbursementReport",
          icon: <FaRupeeSign />,
        },
        {
          text: "EMI Due Report",
          path: "/EmiDueReport",
          icon: <CalendarClock />,
        },
        {
          text: "Collection Report",
          path: "/CollectionReport",
          icon: <Users />,
        },
        // { text: "NPA Report", path: "/NPAReport", icon: <AlertTriangle /> },
        // { text: "Outdated Report", path: "/OutDatedReport", icon: <Clock4 /> },
        {
          text: "Loan Pre-Closure",
          path: "/LoanPreClosure",
          icon: <CheckCircle2 />,
        },
        {
          text: "Approve Loan Settlement",
          path: "/LoanSettlementApprove",
          icon: <CheckCircle2 />,
        },
        {
          text: "Loan Settlement",
          path: "/LoanSettlement",
          icon: <CheckCircle2 />,
        },
        {
          text: "Loan Closer Report",
          path: "/LoanClosureReport",
          icon: <CheckCircle2 />,
        },
        // { text: "Loan Documents", path: "/LegalDocuments", icon: <FileDown /> },
      ],
    },


    {
      icon: <FaUserFriends />,
      text: "Manage Group Loan",
      subItems: [
        // { text: "Group Loan Report", path: "/GroupLoanReportTest", icon: <FaUserPlus /> },
        { text: "Loan Report", path: "/LoanReportTest", icon: <FaChartBar /> },
        { text: "Force Closer", path: "/GroupLoan/ForceCloser", icon: <FaChartBar /> },
        { text: "Applied Loan", path: "/AppliedLoanTest", icon: <FaClock /> },
        {
          text: "Pending Disbursal",
          path: "/PendingDisbursalTest",
          icon: <FaClock />,
        },
        {
          text: "Disbursed Report",
          path: "/DisbursedReportTest",
          icon: <FaRupeeSign />,
        },
        {
          text: "Emi Due Report",
          path: "/EmiDueReportTest",
          icon: <CalendarClock />,
        },
        {
          text: "Collection Report",
          path: "/CollectionReportTest",
          icon: <Users />,
        },
        {
          text: "Single Loan EMI Payment",
          path: "/SingleLoanEmiPayment",
          icon: <FaRupeeSign />,
        },
        { text: "CDS Report", path: "/CDSReport", icon: <Users /> },
        // { text: "NPA Report", path: "/NpaReportTest", icon: <AlertTriangle /> },
        // {
        //   text: "Loan Closer Report",
        //   path: "/LoanCloserReport",
        //   icon: <CheckCircle2 />,
        // },
        // { text: "Demand Sheet", path: "/DemandSheet", icon: <CalendarClock /> },
        { text: "Add CGT", path: "/AddCgt", icon: <FaIdCard /> },
        { text: "CGT Topic", path: "/CgtTopic", icon: <FaIdCard /> },
        { text: "Assign CGT Topic", path: "/GroupLoan/AssignCgtTopic", icon: <FaIdCard /> },
        { text: "Add GRT", path: "/GroupLoan/AddGrt", icon: <FaIdCard /> },
      ],
    },

    {
      icon: <FaUserFriends />,
      text: "Gold Loan",
      subItems: [
        {
          text: "Loan Report",
          path: "/GoldLoan/GoldLoanReport",
          icon: <FaChartBar />,
        },
        { 
          text: "Applied Loans",
          path: "/GoldLoan/AppliedGoldLoan",
          icon: <FaClock /> 
        },

        // {
        //   text: "Pending Disbursal",
        //   path: "/GoldLoan/GoldLoanPendingDisbursal",
        //   icon: <FaClock />,
        // },
        // {
        //   text: "Disbursement Report",
        //   path: "/GoldLoan/DisbursedGoldLoan",
        //   icon: <FaRupeeSign />,
        // },
        // {
        //   text: "EMI Due Report",
        //   path: "/GoldLoan/GoldLoanEmiDueReport",
        //   icon: <CalendarClock />,
        // },
        {
          text: "Collection Report",
          path: "/GoldLoan/GoldLoanCollectionReport",
          icon: <Users />,
        },
      ],
    },

    {
      icon: <FaUser />,
      text: "Banking",
      subItems: [
        // { text: "Search Customer", path: "/SearchCustomer", icon: <FaUserPlus /> },
        { text: "Saving Report", path: "/SavingReport", icon: <FaIdCard /> },
        { text: "RD/DD Report", path: "/RdDdReport", icon: <FaFileAlt /> },
        { text: "FD/MIS Report", path: "/FdMisReport", icon: <FaFileAlt /> },
        {
          text: "Deposit Collection Report",
          path: "/DdCollectionReport",
          icon: <FaFileAlt />,
        },
        {
          text: "Account Closer Info",
          path: "/AccountClosureReport",
          icon: <FaFileAlt />,
        },
      ],
    },

    {
      icon: <FaUser />,
      text: "Accountant",
      subItems: [
        { text: "Branch Wallet", path: "/Accountant/BranchWallet", icon: <FaUserPlus /> },
        {
          text: "Group List",
          path: "/Accountant/GroupList",
          icon: <FaIdCard />,
        },
        {
          text: "Ledger List",
          path: "/Accountant/LedgerList",
          icon: <FaFileAlt />,
        },
        // {
        //   text: "Branch Ledger List",
        //   path: "/Accountant/BranchLedgerList",
        //   icon: <FaFileAlt />,
        // },
        // {
        //   text: "Fund Transfer",
        //   path: "/Accountant/FundTransfer",
        //   icon: <FaFileAlt />,
        // },
        // { text: "Overview", path: "/Accountant/Overview", icon: <FaFileAlt /> },
        // {
        //   text: "Profit Loss",
        //   path: "/Accountant/ProfitLoss",
        //   icon: <FaFileAlt />,
        // },
        {
          icon: <FaUser />,
          text: "Voucher",
          subItems: [
            {
              text: "Day Book (Closing Balance)",
              path: "/Accountant/Voucher/DayBook",
              icon: <FaIdCard />,
            },
            // {
            //   text: "Cash Book",
            //   path: "/Accountant/Voucher/CashBook",
            //   icon: <FaIdCard />,
            // },
            {
              text: "Payment",
              path: "/Accountant/Voucher/Payment",
              icon: <FaIdCard />,
            },
            
            // {
            //   text: "Counter",
            //   path: "/Accountant/Voucher/Counter",
            //   icon: <FaIdCard />,
            // },
            // {
            //   text: "Journal",
            //   path: "/Accountant/Voucher/Journal",
            //   icon: <FaIdCard />,
            // },
            // {
            //   text: "Receipt",
            //   path: "/Accountant/Voucher/Receipt",
            //   icon: <FaIdCard />,
            // },
            // {
            //   text: "Payment Receipt",
            //   path: "/Accountant/Voucher/PaymentReceipt",
            //   icon: <FaIdCard />,
            // },
            {
              text: "Voucher Report",
              path: "/Accountant/Voucher/VoucherEntries",
              icon: <FaIdCard />,
            },
            // {
            //   text: "Trial Balance",
            //   path: "/Accountant/Voucher/TrialBalance",
            //   icon: <FaIdCard />,
            // },
            // {
            //   text: "FY Trial Balance",
            //   path: "/Accountant/Voucher/FyTrialBalance",
            //   icon: <FaIdCard />,
            // },
            // {
            //   text: "FY Opening Balance",
            //   path: "/Accountant/Voucher/FyOpeningBalance",
            //   icon: <FaIdCard />,
            // },
          ],
        },
      ],
    },

    {
      icon: <FaBolt />,
      text: "Quick Access",
      subItems: [
        { text: "Quick Loan", path: "/quick-loan", icon: <FaFileAlt /> },
        {
          text: "Quick Bank Account",
          path: "/quick-bank-account",
          icon: <FaFileAlt />,
        },
        {
          text: "Carreer Request",
          path: "/CareerRequest",
          icon: <FaFileAlt />,
        },
      ],
    },

    // {
    //   icon: <FaUserFriends />,
    //   text: "Demo",
    //   subItems: [
    //     { text: "Dashboard", path: "/Dashboards",  },
    //     { text: "Login Page", path: "/DemoLogin",  },
    //   ],
    // },
  ];

  const renderMenuItems = (items, parentKey = "") => {
    return items.map((item, index) => {
      const key = parentKey ? `${parentKey}-${index}` : `${index}`;
      const activeMain = item.path ? isActive(item.path) : false;
      const isOpen = !!openSubMenu[key]; // check if this submenu is open

      return (
        <div key={key} className="menu1-item">
          <button
            className={`main1-item ${activeMain ? "active" : ""}`}
            onClick={() => handleMainClick(item, key)}
          >
            <span className="icon">{item.icon}</span>
            <span className="text">{item.text}</span>
            {item.subItems && (
              <span className="arrow">
                {isOpen ? <FaChevronDown /> : <FaChevronRight />}
              </span>
            )}
          </button>

          {item.subItems && (
            <div
              className="submenu1"
              style={{ display: isOpen ? "flex" : "none" }}
            >
              {renderMenuItems(item.subItems, key)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <>
      {showOverlay && (
        <div className="sidebar1-overlay" onClick={toggleSidebar} />
      )}
      <div className={`sidebar1 ${isExpanded ? "expanded" : "collapsed"}`}>
        {renderMenuItems(menuItems)}
      </div>
    </>
  );
}
